import { createApi } from '@reduxjs/toolkit/query/react';
import baseQueryWithReauth from './base';
import { Response } from '../../models/shared';
import {
  CommissionCostsDTO, CommissionPanelDTO, CommissionPayoutDTO, CommissionSummaryDTO,
} from '../../models/commission';

interface CommissionRangeArgs {
  from: string;
  to: string;
}

const commissionApi = createApi({
  reducerPath: 'commissionApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['commissions'],
  endpoints: (build) => ({
    getMyCommissions: build.query<CommissionPanelDTO | null, CommissionRangeArgs>({
      query: ({ from, to }) => ({
        url: '/commissions/me',
        method: 'GET',
        params: { from, to },
      }),
      transformResponse: (response: Response<CommissionPanelDTO>): (CommissionPanelDTO | null) => response.data || null,
      providesTags: ['commissions'],
    }),
    getCommissionSummary: build.query<CommissionSummaryDTO | null, CommissionRangeArgs>({
      query: ({ from, to }) => ({
        url: '/commissions/summary',
        method: 'GET',
        params: { from, to },
      }),
      transformResponse: (response: Response<CommissionSummaryDTO>): (CommissionSummaryDTO | null) => response.data || null,
      providesTags: ['commissions'],
    }),
    getCommissionCosts: build.query<CommissionCostsDTO | null, CommissionRangeArgs>({
      query: ({ from, to }) => ({
        url: '/commissions/costs',
        method: 'GET',
        params: { from, to },
      }),
      transformResponse: (response: Response<CommissionCostsDTO>): (CommissionCostsDTO | null) => response.data || null,
      providesTags: ['commissions'],
    }),
    // expected_amount is the total Root approved on screen: the backend refuses
    // the run if the balance moved since, instead of transferring another figure.
    payCommissionBalances: build.mutation<Response<CommissionPayoutDTO[]>, { expected_amount: number }>({
      query: ({ expected_amount }) => ({
        url: '/commissions/pay',
        method: 'POST',
        body: { expected_amount },
      }),
      invalidatesTags: ['commissions'],
    }),
  }),
});

export const {
  useGetMyCommissionsQuery,
  useGetCommissionSummaryQuery,
  useGetCommissionCostsQuery,
  usePayCommissionBalancesMutation,
} = commissionApi;
export { commissionApi };
